import React from 'react'
import { createPortal } from 'react-dom'
import CollectionsSet from '../../components/CollectionsSet'
import { useEvergreenMessaging } from '../../components/EvergreenUrgentMessaging'
import LocalizeStationModal from '../../components/LocalizeStationModal'
import Spinner from '../../components/Spinner'
import UrgentMessageModal from '../../components/UrgentMessageModal'
import useHomeScreenLogic from './hooks'

function HomeScreen() {
  const {
    collections,
    toggleMessageUI,
    toggleLocalizeModal,
    handleCloseModal,
    handleDismissLocalizeModal,
    isDoneFetching,
  } = useHomeScreenLogic()

  const { getCollectionsWithBanner } = useEvergreenMessaging()

  const doneFetching = isDoneFetching()

  // Inject banner after Spotlight collection when messaging endpoint responds successfully
  const collectionsWithBanner = React.useMemo(
    () => getCollectionsWithBanner(collections || []),
    [collections, getCollectionsWithBanner]
  )

  return (
    <>
      {!doneFetching && <Spinner />}
      {doneFetching && (
        <>
          {toggleLocalizeModal &&
            createPortal(
              <LocalizeStationModal
                dismissModalHandler={handleDismissLocalizeModal}
              />,
              document.getElementById('app') as HTMLElement
            )}
          {toggleMessageUI &&
            !toggleLocalizeModal &&
            createPortal(
              <UrgentMessageModal onCloseModal={handleCloseModal} />,
              document.getElementById('app') as HTMLElement
            )}
          <CollectionsSet collections={collectionsWithBanner} />
        </>
      )}
    </>
  )
}

export default HomeScreen
